export const COLLECTIONS_ROUTE_PATH = '/collections';
export const COLLECTION_ROUTE_PATH = '/collections/:id';

export const PROPERTY_COLLECTIONS_ROUTE_PATH = '/collections/property/:propertyId';
